module.exports = __webpack_public_path__ + "img/undraw_collecting_fjjl.cfb85f5f.svg";